import { Vue, Options } from 'vue-class-component';
import { IThermoRoomObjectDTO } from '@/../client-generator/generated-clients/plants';
import plantsClient from '@/core/services/plants';
import { SET_APP_LOADING } from '@/core/store/action-types';
import ThermostatPreferences from './ThermostatPreferences/ThermostatPreferences.vue';

@Options({
  name: 'DialogThermoObjectSettings',
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    plantId: {
      type: String,
      required: true,
    },
    roomId: {
      type: String,
      required: true,
    },
    roomObjectId: {
      type: String,
      required: true,
    },
  },
  watch: {
    isVisible(newValue) {
      this.isDialogVisible = newValue;
      if (this.isDialogVisible) this.fetchRoomObject();
    },
  },
  emits: ['hide-dialog', 'confirm'],
  components: {
    ThermostatPreferences,
  },
})
export default class DialogThermoObjectSettings extends Vue {
  isVisible!: boolean;
  isDialogVisible = false;
  plantId!: number;
  roomId!: string;
  roomObjectId!: string;
  roomObject: IThermoRoomObjectDTO | null = null;

  async mounted() {
    this.isDialogVisible = this.isVisible;
  }

  async fetchRoomObject() {
    this.$store.dispatch(SET_APP_LOADING, true);
    this.roomObject = await plantsClient.thermoGET(
      this.plantId,
      this.roomId,
      this.roomObjectId
    );
    this.$store.dispatch(SET_APP_LOADING, false);
  }

  handleHideDialog() {
    this.isDialogVisible = false;
  }

  doHideDialog() {
    this.$emit('hide-dialog');
  }

  doConfirm() {
    this.$emit('confirm');
    this.handleHideDialog();
  }
}
